export default __webpack_public_path__ + "static/service-branding-f38cfda0c8df8f2a046585b572d03cf2.svg";